var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.img.id)+". "+_vm._s(_vm.img.desc))]),_c('div',{staticClass:"centered"},[_c('img',{staticClass:"size-limit",attrs:{"src":_vm.img.src,"alt":_vm.img.desc}})])])}
var staticRenderFns = []

export { render, staticRenderFns }